import React from "react";

import { Outlet } from "react-router-dom";

import ProfilePanel from "./ProfilePanel";

const Profile: React.FC = () => {
  return (
    <ProfilePanel>
      <Outlet />
    </ProfilePanel>
  );
};

export default Profile;
